var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5557 13.3991C11.5557 12.6446 11.8554 11.921 12.3889 11.3874C12.9224 10.8539 13.646 10.5542 14.4005 10.5542L15.823 13.3991L14.7277 15.0411C15.1622 16.0792 15.9877 16.9047 17.0258 17.3392L18.6678 16.2439L21.5127 17.6664C21.5127 18.4209 21.213 19.1445 20.6795 19.678C20.1459 20.2115 19.4223 20.5112 18.6678 20.5112C16.7816 20.5112 14.9726 19.7619 13.6388 18.4281C12.305 17.0943 11.5557 15.2853 11.5557 13.3991Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2603 22.9213C14.053 23.9589 16.1619 24.309 18.1938 23.9066C20.2256 23.5041 22.0418 22.3764 23.3036 20.7337C24.5654 19.0911 25.1868 17.0456 25.0519 14.9787C24.9169 12.9117 24.0349 10.9644 22.5703 9.49974C21.1056 8.03508 19.1583 7.15306 17.0913 7.01814C15.0244 6.88321 12.9789 7.50458 11.3363 8.7664C9.69362 10.0282 8.56593 11.8444 8.16344 13.8762C7.76095 15.9081 8.11113 18.017 9.1487 19.8097L8.03653 23.1302C7.99474 23.2555 7.98867 23.39 8.01901 23.5186C8.04936 23.6471 8.1149 23.7647 8.20831 23.8581C8.30172 23.9515 8.4193 24.0171 8.54786 24.0474C8.67643 24.0778 8.81091 24.0717 8.93622 24.0299L12.2603 22.9213Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/iconWhatsapp.02609dc9fd1fb94ff5492339d57e4de1.svg";
export { ForwardRef as ReactComponent };